import { USE_THIS_PAYMENT } from 'constants/checkoutButtons';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import styles from 'styles/components/checkout/caap/payment/paymentlist/continueButtonBottom.scss';

const ContinueButtonBottom = componentParams => {
  const {
    canUseThisPayment,
    isFetchingCheckoutData,
    onUseThisPaymentClick,
    selectedPaymentId,
    selectedPaymentNeedsConfirmation,
    showAsRadio
  } = componentParams;

  if (!selectedPaymentNeedsConfirmation
    // this OR check might be able to go away when mafia fixes things:
    // https://github01.zappos.net/mweb/marty/issues/2510
    || (showAsRadio && selectedPaymentId === 'savedBalance')) {
    return (
      <Row mobileOnly={true}>
        <RowSpan span="12">
          <button
            className={styles.checkoutPrimaryButton}
            disabled={!canUseThisPayment || isFetchingCheckoutData}
            id={`${USE_THIS_PAYMENT}-bottom`}
            onClick={onUseThisPaymentClick}
            type="button">
            Continue
          </button>
        </RowSpan>
      </Row>
    );
  }

  return null;
};

export default ContinueButtonBottom;
